/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { addModal, removeModal } from 'Redux/modules/modal/actions';
import { Button, Grid, Modal } from 'semantic-ui-react';
import humps from 'humps';
import { FastField, Form, Formik } from 'formik';
import { InputField } from 'Modules/Formik';
import { iamChangePassword } from 'Redux/modules/auth/actions';

import css from './ChangePasswordModal.less';
import { schemaValidation } from './Validation';
import ChangePasswordSuccess from './ChangePasswordSuccess';

const initialValues = {
  oldPassword: '',
  newPassword: '',
  confirmPassword: '',
};

const ChangePasswordModal = ({ id }) => {
  const [err, setErr] = useState();
  const ref = useRef(null);

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const onSubmit = async values => {
    const { oldPassword, newPassword } = values;
    try {
      await dispatch(iamChangePassword({ oldPassword, newPassword }));
      dispatch(removeModal(id));
      dispatch(
        addModal({
          type: 'warningModal',
          id: 2,
          data: {
            closeOnDimmerClick: false,
            content: (
              <ChangePasswordSuccess
                onClose={() => {
                  dispatch(removeModal(2));
                  window.location.href = '/login';
                }}
              />
            ),
            hideFooter: true,
            size: 'small',
            onClose: () => {
              dispatch(removeModal(2));
              window.location.href = '/login';
            },
          },
        }),
      );
      setErr(undefined);
    } catch (error) {
      setErr(error.data?.errors);
    }
  };

  useEffect(() => {
    err?.forEach(element => {
      ref.current.setFieldError(humps.camelize(element.field), element.message);
    });
  }, [err]);

  return (
    <div>
      <Modal onClose={onClose} open size="mini" closeIcon>
        <Modal.Header>Change Password</Modal.Header>
        <Modal.Content>
          <Formik
            className={css.form}
            initialValues={initialValues}
            validationSchema={schemaValidation}
            validateOnChange
            innerRef={ref}
            onSubmit={onSubmit}>
            {() => {
              return (
                <Form>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <FastField
                          fluid
                          name="oldPassword"
                          component={InputField}
                          type="password"
                          placeholder="Current Password"
                          label="Your Current Password"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <FastField
                          fluid
                          type="password"
                          name="newPassword"
                          component={InputField}
                          placeholder="New Password"
                          label="New Password"
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column>
                        <FastField
                          fluid
                          type="password"
                          name="confirmPassword"
                          component={InputField}
                          placeholder="Confirm Password"
                          label="Confirm Password"
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              onClose();
            }}>
            Close
          </Button>
          <Button
            primary
            onClick={() => {
              ref.current.submitForm();
            }}>
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default ChangePasswordModal;
